/** Two-letter initials for avatars. Empty or whitespace-only names fall back to "?". */
export function initialsFor(name) {
  const words = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  return words
    .map((word) => word[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
